import { render, staticRenderFns } from "./TipoAcuerdos.vue?vue&type=template&id=7d174bfe"
import script from "./TipoAcuerdos.vue?vue&type=script&lang=js"
export * from "./TipoAcuerdos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports